import React, { useState } from "react";
import "./FAQSection.scss";

const faqData = [
  {
    question: "¿Que tipo de maquinaria manejamos?",
    answer:
      "Manejamos una amplia gama de maquinaria industrial como centros de maquinado CNC, tornos CNC, rectificadoras, fresadoras, láser industrial, compresores y montacargas, entre otros equipos diseñados para alto rendimiento.",
  },
  {
    question: "¿Aún tienes dudas?  ",
    answer:
      "En MAKINARIA DIMA te asesoramos de forma directa para ayudarte a elegir el equipo ideal según tu operación, presupuesto y necesidades. Contáctanos y recibe atención personalizada.",
  },
  {
    question: "¿Dónde están ubicados?",
    answer:
      "Nos ubicamos en C. Ingenieros Industriales 272, Col. Ex Hacienda de San Francisco Huatengo, 43774, Santiago Tulantepec, Hidalgo.",
  },
];

const FAQItem = ({ item, isActive, onClick }) => {
  return (
    <article className={`faq-section__item ${isActive ? "active" : ""}`}>
      <button className="faq-section__question" onClick={onClick} type="button">
        <span>{item.question}</span>
        <span className="faq-section__icon"></span>
      </button>

      <div className="faq-section__answer-wrapper">
        <div className="faq-section__answer">
          <p>{item.answer}</p>
        </div>
      </div>
    </article>
  );
};

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <div className="faq-section__heading">
          <div className="faq-section__eyebrow">Preguntas frecuentes</div>

          <h2 className="faq-section__title">
            Resolvemos tus dudas para que compres con confianza.
          </h2>

          <p className="faq-section__subtitle">
            Si tienes una duda específica sobre un equipo o sobre el proceso de
            atención, también puedes contactarnos directamente.
          </p>
        </div>

        <div className="faq-section__layout">
          <div className="faq-section__list">
            {faqData.map((item, index) => (
              <FAQItem
                key={index}
                item={item}
                isActive={activeIndex === index}
                onClick={() => handleToggle(index)}
              />
            ))}
          </div>

          <div className="faq-section__side">
            <div className="faq-section__card">
              <span className="faq-section__card-label">¿Aún tienes dudas?</span>
              <h3>Podemos orientarte directamente sobre el equipo que buscas</h3>
              <p>
                Si necesitas más información sobre maquinaria, disponibilidad o
                forma de entrega, contáctanos y con gusto te apoyamos.
              </p>

              <a
                href={`https://wa.me/525515898591?text=${encodeURIComponent(
                  "Hola, me gustaría recibir más información sobre su maquinaria industrial."
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="header__cta"
              >
                Solicitar información
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;